import { render, staticRenderFns } from "./AddApplication.vue?vue&type=template&id=0d201bfa"
import script from "./AddApplication.vue?vue&type=script&lang=js"
export * from "./AddApplication.vue?vue&type=script&lang=js"
import style0 from "./AddApplication.vue?vue&type=style&index=0&id=0d201bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports